import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import axios from 'axios'

import DeleteModal from 'pages/parts/DeleteModal'
import ProfileModal from 'pages/parts/ProfileModal'
import DevicesModal from 'pages/parts/DevicesModal'
// Import menuDropdown
import logo from "assets/images/logo.png";
import LanguageDropdown from "../../LanguageDropdown";
import ThemeDropdown from "../../ThemeDropdown";
import { TOGGLE_LEFT_MENU } from "store/layout/actions";
import { SET_ACCOUNT, CHANGE_ACCOUNT } from 'store/account/action'
import { clearTemporaryStorage, formatMoney } from 'helpers/helpers'

import { httpOk, GET, POST, PUT, DELETE, closeWebSession } from "helpers/api";
import { getBackendUrl } from 'helpers/env'
import { setBusinessDayStartFromPoses } from 'helpers/businessDay'

/** Синхронно с CSS: на телефоне меню выезжает поверх и прячется после выбора пункта — max-width: 600px */
const DESKTOP_MENU_MQ = '(min-width: 601px)'
/** На десктопе меню скрыли бургером — помним выбор между перезагрузками */
const MENU_HIDDEN_KEY = 'left_menu_hidden'

function isMenuHiddenSaved() {
	try {
		return localStorage.getItem(MENU_HIDDEN_KEY) === '1'
	} catch (e) {
		return false
	}
}

function Header() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	const layoutSelector = useSelector(state => state.layout)
	const reduxAccount = useSelector(state => state.account)

	const [pos, setPos] = useState(null)
	const [poses, setPoses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalProfile, setModalProfile] = useState(false)
	const [modalDevices, setModalDevices] = useState(false)
	const [modalChangePos, setModalChangePos] = useState(false)
	const [modalAccount, setModalAccount] = useState(false)
	const [modalChangeAccount, setModalChangeAccount] = useState({ 'bool': false, 'data': [] })
	const [showUserDropdown, setShowUserDropdown] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ 'id': 0, 'index': 0 })
	const [unreadNotifications, setUnreadNotifications] = useState(0)
	const [showNotificationsBell, setShowNotificationsBell] = useState(false)
	const [showNotifDropdown, setShowNotifDropdown] = useState(false)
	const [notifList, setNotifList] = useState([])
	const [notifLoading, setNotifLoading] = useState(false)
	const notifRef = useRef(null)

	function tToggle() {
		const show = !layoutSelector.showleftMenu
		dispatch(TOGGLE_LEFT_MENU(show));
		// Запоминаем только десктопный выбор: на телефоне меню и так прячется само
		if (window.matchMedia(DESKTOP_MENU_MQ).matches) {
			try {
				if (show) localStorage.removeItem(MENU_HIDDEN_KEY)
				else localStorage.setItem(MENU_HIDDEN_KEY, '1')
			} catch (e) { }
		}
	}

	function toggleFullscreen() {
		if (
			!document.fullscreenElement &&
			!document.mozFullScreenElement &&
			!document.webkitFullscreenElement
		) {
			// current working methods
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullscreen) {
				document.documentElement.webkitRequestFullscreen(
					Element.ALLOW_KEYBOARD_INPUT
				);
			}
		} else {
			if (document.cancelFullScreen) {
				document.cancelFullScreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen();
			}
		}
	}

	async function toggleModalChangePos(bool) {
		setModalChangePos(bool)
	}

	async function toggleModalChangeAccount(bool = false) {
		if (bool) {
			const response = await axios.post(`${getBackendUrl()}/api/users/linked-accounts`,
				{
					'user_id': reduxAccount.main_user_id
				},
				{
					headers: {
						'Authorization': `Bearer ${reduxAccount.token}`
					}
				});

			//const response = await POST('/users/linked-accounts', { 'user_id': reduxAccount.main_user_id }, { 'notification': false })
			if (httpOk(response)) setModalChangeAccount({ ...modalChangeAccount, 'bool': bool, 'data': response.data.data })
			return
		}

		setModalChangeAccount(bool)
	}

	async function toggleModalAccount(bool = false) {
		if (bool) toggleModalChangeAccount(false)
		setModalAccount(bool)
	}

	async function changePos(item) {
		const response = await PUT('/users/change-pos', { 'pos_id': item.id }, { 'loader': true })
		if (httpOk(response)) {
			var reduxAccountCopy = JSON.parse(JSON.stringify(reduxAccount))
			reduxAccountCopy.pos_id = response.data.pos_id
			reduxAccountCopy.wms_id = response.data.wms_id

			dispatch(CHANGE_ACCOUNT(reduxAccountCopy))
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		}
	}

	async function changeAccount(item) {
		const response = await POST('/users/change-account', {
			'user_id': item.linked_user_id
		}, { 'loader': true })

		if (httpOk(response)) {
			var reduxAccountCopy = JSON.parse(JSON.stringify(reduxAccount))
			reduxAccountCopy = { ...response.data, 'main_user_id': reduxAccount.main_user_id }

			localStorage.setItem("login", response.data.login.toLowerCase());
			localStorage.setItem("role", response.data.role);
			localStorage.setItem('token', response.data.token)
			dispatch(SET_ACCOUNT(reduxAccountCopy))
			setTimeout(() => {
				window.location.reload();
			}, 1000);
		}
	}

	async function addAccount() {
		const response = await POST('/users/link-account', selectedItem, { 'loader': true, 'notification': true })
		if (httpOk(response)) toggleModalAccount()
	}

	async function deleteItem() {
		const response = await DELETE(`/users/linked-accounts/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			toggleModalChangeAccount(true)
		}
	}

	async function logout() {
		await closeWebSession()
		dispatch({ 'type': 'USER_LOGGED_OUT', payload: null })
		clearTemporaryStorage()
		navigate('/auth/login')
	}

	async function getBalance() {
		const response = await GET('/pos-balance')

		if (httpOk(response)) setPos(response.data)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) {
			setPoses(response.data)
			// Начало операционного дня текущей точки — от него пресеты «Сегодня/Вчера» в отчётах
			setBusinessDayStartFromPoses(response.data, reduxAccount.pos_id)
		}
	}

	// Живой счётчик непрочитанных для колокольчика. Эндпоинт гейтится правом notifications,
	// поэтому у кого доступа нет — колокольчик просто не показываем.
	async function getUnreadNotifications() {
		const response = await GET('/notifications/unread-count', {}, { notification: false, silent: true })
		if (httpOk(response)) {
			setShowNotificationsBell(true)
			setUnreadNotifications(response.data.unread ?? 0)
			return true
		}
		setShowNotificationsBell(false)
		return false
	}

	// Открыть/закрыть мини-окно колокольчика и подгрузить последние уведомления
	async function toggleNotifDropdown() {
		const next = !showNotifDropdown
		setShowNotifDropdown(next)
		if (next) {
			setNotifLoading(true)
			const response = await GET('/notifications?page=0&size=6', {}, { notification: false })
			if (httpOk(response)) {
				setNotifList(response.data.data)
				setUnreadNotifications(response.data.unread ?? 0)
			}
			setNotifLoading(false)
		}
	}

	async function markOneNotifRead(id) {
		setNotifList(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n))
		const response = await POST('/notifications/read', { 'ids': [id] }, { 'notification': false })
		if (httpOk(response)) getUnreadNotifications()
	}

	// Клик по уведомлению: отметить прочитанным и увести на экран действия (action_url с бэка).
	// Уведомления без действия просто отмечаются прочитанными.
	function openNotification(item) {
		if (!item.is_read) markOneNotifRead(item.id)
		if (!item.action_url) return

		setShowNotifDropdown(false)
		navigate(item.action_url)
	}

	async function markAllNotifRead() {
		setNotifList(prev => prev.map(n => ({ ...n, 'is_read': true })))
		const response = await POST('/notifications/read', { 'ids': [] }, { 'notification': false })
		if (httpOk(response)) getUnreadNotifications()
	}

	function goToNotificationsCenter() {
		setShowNotifDropdown(false)
		navigate('/notifications-center')
	}

	// "2026-08-15 18:25:46.569338" -> "15.08.26 18:25"
	function formatNotifDate(raw) {
		if (!raw) return ''
		const m = String(raw).replace('T', ' ').match(/^(\d{4})-(\d{2})-(\d{2})[ ]+(\d{2}):(\d{2})/)
		if (!m) return raw
		return `${m[3]}.${m[2]}.${m[1].slice(2)} ${m[4]}:${m[5]}`
	}

	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowUserDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	useEffect(() => {
		if (!localStorage.getItem('login')) return
		getBalance()
		if (reduxAccount.role !== 'ROLE_PARTNER') {
			getPoses()
		}
	}, [reduxAccount.pos_id]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		function handleBalanceUpdated() {
			getBalance()
		}
		window.addEventListener('pos-balance-updated', handleBalanceUpdated)
		return () => window.removeEventListener('pos-balance-updated', handleBalanceUpdated)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	// Поллинг непрочитанных: для любой роли клиента — получателем уведомления в настройках
	// можно назначить любого сотрудника, и он должен увидеть колокольчик. Лента персональная.
	// ROLE_ADMIN и ROLE_PARTNER сюда не входят: центр уведомлений привязан к точке клиента,
	// у них он всегда пустой — колокольчик им не рисуем.
	useEffect(() => {
		if (!localStorage.getItem('login')) return
		if (['ROLE_ADMIN', 'ROLE_PARTNER'].includes(reduxAccount.role)) return

		let interval = null
		getUnreadNotifications().then((ok) => {
			if (ok) interval = setInterval(getUnreadNotifications, 1800000)
		})
		return () => { if (interval) clearInterval(interval) }
	}, [reduxAccount.role]) // eslint-disable-line react-hooks/exhaustive-deps

	// Закрытие мини-окна колокольчика по клику вне его
	useEffect(() => {
		function handleClickOutsideNotif(event) {
			if (notifRef.current && !notifRef.current.contains(event.target)) {
				setShowNotifDropdown(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutsideNotif)
		return () => document.removeEventListener('mousedown', handleClickOutsideNotif)
	}, [])

	useEffect(() => {
		const mq = window.matchMedia(DESKTOP_MENU_MQ)

		// На десктопе меню открыто, если пользователь сам его не скрыл
		const openMenuOnDesktop = () => {
			if (mq.matches) dispatch(TOGGLE_LEFT_MENU(!isMenuHiddenSaved()))
		}

		openMenuOnDesktop()
		mq.addEventListener('change', openMenuOnDesktop)
		return () => mq.removeEventListener('change', openMenuOnDesktop)
	}, [dispatch])

	const currentPos = poses.find(option => Number(option.id) === Number(reduxAccount.pos_id))
	const posName = currentPos?.name || reduxAccount.pos_name || '—'
	const posBalance = pos?.balance ?? null
	const balanceBadgeClass = posBalance < 0
		? 'header-balance-badge-danger'
		: posBalance > 0
			? 'header-balance-badge-success'
			: ''

	return (
		<>
			<header id="page-topbar" className={layoutSelector.showleftMenu ? 'sidebar-active-left' : 'sidebar-left'}>
				<div className={`navbar-header${pos?.balance < 0 ? ' navbar-header-balance-danger' : ''}`}>
					{/* Логотип и бургер — одной группой слева, иначе space-between ставит бургер посередине */}
					<div className="d-flex align-items-center">
						<div className="second-sidebar-logo" role="button" tabIndex={0}
							style={{ cursor: 'pointer' }}
							onClick={() => navigate('/analytics/dashboard')}
							onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/analytics/dashboard') }}>
							<img src={logo} alt="" width={120} />
						</div>

						<div className="m-butger-button">
							<button type="button" id="vertical-menu-btn"
								className="btn btn-sm px-3 header-item waves-effect vertical-menu-btn"
								title={t(layoutSelector.showleftMenu ? 'hide_menu' : 'show_menu')}
								onClick={() => tToggle()}>
								<i className="uil-bars fz-20" />
							</button>
						</div>
					</div>

					<div className="d-flex align-items-center">
						<LanguageDropdown />
						<ThemeDropdown />

						<Dropdown className="d-lg-inline-block">
							{showNotificationsBell &&
								<div className="position-relative d-inline-block" ref={notifRef}>
									<button type="button" className="btn header-item noti-icon waves-effect position-relative"
										title={t('notification_center')}
										onClick={toggleNotifDropdown}>
										<i className="uil-bell"></i>
										{unreadNotifications > 0 &&
											<span className="badge bg-danger" style={{
												'position': 'absolute',
												'fontSize': '10px',
												'right': '2px',
												'top': '4px',
											}}>
												{unreadNotifications > 99 ? '99+' : unreadNotifications}
											</span>
										}
									</button>

									{showNotifDropdown &&
										<div style={{
											'position': 'absolute',
											'top': '100%',
											'right': 0,
											'zIndex': 1050,
											'width': '340px',
											'maxWidth': '90vw',
											'background': 'var(--dark-surface, #fff)',
											'border': '1px solid var(--dark-border, #e5e7eb)',
											'borderRadius': '10px',
											'boxShadow': '0 8px 28px rgba(20, 25, 34, .14)',
											'overflow': 'hidden',
										}}>
											<div style={{
												'display': 'flex',
												'justifyContent': 'space-between',
												'alignItems': 'center',
												'padding': '12px 14px',
												'borderBottom': '1px solid var(--dark-border, #eef0f2)',
											}}>
												<b style={{ 'fontSize': '.92rem' }}>{t('notification_center')}</b>
												{unreadNotifications > 0 &&
													<span className="badge bg-danger">{unreadNotifications}</span>
												}
											</div>

											<div style={{ 'maxHeight': '360px', 'overflowY': 'auto', 'padding': '8px' }}>
												{notifLoading &&
													<div style={{ 'padding': '28px', 'textAlign': 'center', 'color': 'var(--dark-text-muted, #9ca3af)' }}>
														<div className="spinner-border spinner-border-sm" role="status"></div>
													</div>
												}
												{!notifLoading && notifList.map((item, index) => (
													<div key={index}
														onClick={() => openNotification(item)}
														title={item.action_url ? t('go_to_action') : ''}
														style={{
															'padding': '10px 12px',
															'marginBottom': '8px',
															'borderRadius': '8px',
															'border': '1px solid var(--dark-border, #eceef1)',
															'borderLeft': item.is_read ? '3px solid var(--dark-border, #d7dbe0)' : '3px solid #2563a8',
															'background': item.is_read ? 'var(--dark-surface, #fff)' : 'var(--dark-surface-2, #f4f8ff)',
															'cursor': (item.action_url || !item.is_read) ? 'pointer' : 'default',
														}}>
														<div style={{
															'display': 'flex',
															'justifyContent': 'space-between',
															'alignItems': 'center',
															'gap': '8px',
															'marginBottom': '4px',
														}}>
															<div style={{
																'fontWeight': 700,
																'fontSize': '.84rem',
																'color': 'var(--dark-text-strong, #14181f)',
																'overflow': 'hidden',
																'textOverflow': 'ellipsis',
																'whiteSpace': 'nowrap',
															}}>
																{item.title || t('notification')}
															</div>
															<span style={{
																'flex': 'none',
																'fontSize': '.7rem',
																'fontWeight': 600,
																'color': 'var(--dark-fg-primary, #2563a8)',
																'background': 'var(--dark-tint-primary, #e7effb)',
																'padding': '2px 7px',
																'borderRadius': '6px',
																'whiteSpace': 'nowrap',
															}}>
																{formatNotifDate(item.created_at)}
															</span>
														</div>
														<div style={{
															'fontSize': '.8rem',
															'color': 'var(--dark-text, #5b6470)',
															'lineHeight': 1.4,
															'display': '-webkit-box',
															'WebkitLineClamp': 2,
															'WebkitBoxOrient': 'vertical',
															'overflow': 'hidden',
														}}>
															{item.message}
														</div>
														{item.action_url &&
															<div style={{
																'marginTop': '5px',
																'fontSize': '.75rem',
																'fontWeight': 600,
																'color': 'var(--dark-fg-primary, #2563a8)',
															}}>
																{t('go_to_action')} <i className="uil uil-angle-right-b"></i>
															</div>
														}
													</div>
												))}
												{!notifLoading && notifList.length === 0 &&
													<div style={{ 'padding': '24px 14px', 'textAlign': 'center', 'color': 'var(--dark-text-muted, #9ca3af)', 'fontSize': '.85rem' }}>
														{t('no_notifications')}
													</div>
												}
											</div>

											<div style={{
												'padding': '10px 14px',
												'borderTop': '1px solid var(--dark-border, #eef0f2)',
												'display': 'flex',
												'justifyContent': 'space-between',
												'alignItems': 'center',
											}}>
												{unreadNotifications > 0
													? <span onClick={markAllNotifRead}
														style={{
															'cursor': 'pointer', 'color': 'var(--dark-text-muted, #6b7280)', 'fontSize': '.82rem', 'fontWeight': 600,
															'display': 'flex', 'alignItems': 'center', 'gap': '4px',
														}}>
														<i className="uil uil-check-circle"></i>
														{t('mark_all_read')}
													</span>
													: <span></span>
												}
												<span onClick={goToNotificationsCenter}
													style={{ 'cursor': 'pointer', 'color': 'var(--dark-fg-primary, #2563a8)', 'fontSize': '.82rem', 'fontWeight': 600, 'textDecoration': 'underline' }}>
													{t('read_more')}
												</span>
											</div>
										</div>
									}
								</div>
							}
							<button type="button" className="btn header-item noti-icon waves-effect"
								onClick={() => toggleModalChangeAccount(true)}>
								<i className="uil-user-plus"></i>
							</button>
							{reduxAccount.role !== 'ROLE_PARTNER' && !!(poses.length > 1) &&
								<button type="button" className="btn header-item noti-icon waves-effect position-relative"
									onClick={toggleModalChangePos}>
									<i className="uil-shop"></i>
									<span style={{
										'position': 'absolute',
										'fontSize': '12px',
										'right': '4px',
										'top': '7px',
									}}>
										{poses.length}
									</span>
								</button>
							}
							<button type="button" className="btn header-item noti-icon waves-effect" data-toggle="fullscreen"
								onClick={toggleFullscreen}>
								<i className="uil-minus-path"></i>
							</button>
							{/* Помощь — в хедере, а не в меню: доступна всем ролям без отдельного права
							и не удлиняет список рабочих разделов */}
							<button type="button" className="btn header-item noti-icon waves-effect"
								title={t('help')}
								onClick={() => navigate('/help')}>
								<i className="uil-question-circle"></i>
							</button>
						</Dropdown>

						{posBalance !== null &&
							<div
								className={`header-balance-badge ${balanceBadgeClass} ${reduxAccount.role === 'ROLE_OWNER' ? 'header-balance-badge-clickable' : ''}`}
								title={reduxAccount.role === 'ROLE_OWNER' ? 'Тарифы, услуги и балансы филиалов' : t('balance')}
								role={reduxAccount.role === 'ROLE_OWNER' ? 'button' : undefined}
								tabIndex={reduxAccount.role === 'ROLE_OWNER' ? 0 : undefined}
								onClick={() => reduxAccount.role === 'ROLE_OWNER' && navigate('/subscription')}
								onKeyDown={(event) => {
									if (reduxAccount.role === 'ROLE_OWNER' && (event.key === 'Enter' || event.key === ' ')) {
										navigate('/subscription')
									}
								}}>
								<span className="header-balance-badge-label">{t('balance')}</span>
								<span className="header-balance-badge-value">{formatMoney(posBalance)}</span>
							</div>
						}

						{reduxAccount.role !== 'ROLE_PARTNER' &&
						<div className="header-account-session ms-2" aria-label={`${posName}, ${reduxAccount.login}`}>
							<span className="header-account-session-id">
								<span className="header-account-session-id-value">{reduxAccount.pos_id}</span>
							</span>
							<span className="header-account-session-body">
								<span className="header-account-session-login">{reduxAccount.login}</span>
								<span className="header-account-session-pos">{posName}</span>
							</span>
						</div>
						}

						<div className="d-lg-inline-block ms-2 dropdown">
							<button type="button" className="btn header-item noti-icon waves-effect p-0" ref={wrapperRef}>
								<div className="profile-dropdown">
									<div
										className={`profile-dropdown-toggle header-profile-avatar ${pos?.balance < 0 ? 'danger' : 'success'}`}
										onClick={() => setShowUserDropdown(!showUserDropdown)}>
										<i className="uil uil-user" color="#fff"></i>
									</div>
									{showUserDropdown &&
										<div className="profile-dropdown-menu">
											<div className="profile-dropdown-item">
												<div>{t('name')}:</div>
												<div>{reduxAccount.first_name}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>{t('login')}:</div>
												<div>{reduxAccount.login}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>ID:</div>
												<div>{reduxAccount.id}</div>
											</div>
											<div className="profile-dropdown-item">
												<div>{t('balance')}:</div>
												<b className={`${pos?.balance < 0 && 'text-danger'}`}>
													{formatMoney(pos?.balance)}
												</b>
											</div>
											{reduxAccount.role === 'ROLE_OWNER' &&
												<>
													<div className="profile-dropdown-item second"
														onClick={() => {
															navigate('/subscription')
															setShowUserDropdown(false)
														}}>
														{t('balance')}
														<i className="uil-wallet"></i>
													</div>
													<div className="profile-dropdown-item second"
														onClick={() => {
															setModalProfile(true)
															setShowUserDropdown(false)
														}}>
														{t('settings')}
														<i className="uil-cog"></i>
													</div>
												</>
											}
											<div className="profile-dropdown-item second"
												onClick={() => {
													setModalDevices(true)
													setShowUserDropdown(false)
												}}>
												{t('devices_title')}
												<i className="uil-desktop"></i>
											</div>
											<div className="profile-dropdown-item second d-none"
												onClick={() => {
													navigate('/payment')
													setShowUserDropdown(false)
												}}>
												{t('payment')}
												<i className="uil-transaction"></i>
											</div>
											<div className="profile-dropdown-item second"
												onClick={() => logout()}>
												<div>
													{t('logout')}
												</div>
												<i className="uil-signin"></i>
											</div>
										</div>
									}
								</div>
							</button>
						</div>
					</div>
				</div>
			</header>

			<ProfileModal
				show={modalProfile}
				setShow={setModalProfile}>
			</ProfileModal>

			<DevicesModal
				show={modalDevices}
				setShow={setModalDevices}>
			</DevicesModal>

			<Modal show={modalChangePos} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalChangePos(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('poses')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ 'height': '300px', 'overflow': 'auto' }}>
						{poses.map((item, index) => (
							<div key={index}
								className={`d-flex justify-content-between mb-2 ${item.id === reduxAccount.pos_id ? 'text-primary' : ''}`}>
								<div className="d-flex gap-2">
									<p className="fw-600 vertical-center">{item.id}</p>
									<p className="fw-600 vertical-center">{item.name}</p>
								</div>
								<div className="table-action-button table-action-success-button"
									onClick={() => changePos(item)}>
									<i className="uil uil-check"></i>
								</div>
							</div>
						))}
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalChangeAccount.bool} animation={false}
				onHide={() => toggleModalChangeAccount()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('users')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ 'height': '300px', 'overflow': 'auto' }}>
						{modalChangeAccount?.data?.map((item, index) => (
							<div className="d-flex justify-content-between mb-2" key={index}>
								<div className="d-flex gap-2">
									<p className="fw-600 vertical-center">{index + 1}</p>
									<p className="fw-600 vertical-center">{item.login}</p>
								</div>
								<div className="d-flex gap-2">
									<div className="table-action-button table-action-success-button"
										onClick={() => changeAccount(item)}>
										<i className="uil uil-check"></i>
									</div>
									<div className="table-action-button table-action-danger-button"
										onClick={() => {
											setDeleteModalParams({ id: item.id, index: index });
											setModalDelete(true)
										}}>
										<i className="uil uil-times"></i>
									</div>
								</div>
							</div>
						))}
					</div>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => toggleModalChangeAccount()}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => toggleModalAccount(true)}>
							{t('add')}
						</button>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalAccount} animation={false}
				onHide={() => toggleModalAccount()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logging_in')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group">
						<label>{t('login')}</label>
						<input type="text" className="form-control"
							autoComplete="off"
							name="account_login"
							onChange={(e) => setSelectedItem({ ...selectedItem, 'account_login': e.target.value })} />
					</div>
					<div className="form-group">
						<label>{t('password')}</label>
						<input type="text" className="form-control"
							autoComplete="off"
							name="account_password"
							onChange={(e) => setSelectedItem({ ...selectedItem, 'account_password': e.target.value })} />
					</div>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => toggleModalAccount()}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => addAccount()}>
							{t('enter')}
						</button>
					</div>
				</Modal.Body>
			</Modal>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	);
};

export default Header
